<lib-card [overflow]="false" containerHeight="auto">
  <lib-card-header>
    <div class="d-flex justify-content-between mb-3">
      <div class="font-weight-bold d-flex align-items-start">
        {{'MONTHS.TIMELINE' | translate}}
        @if (pin) {
          <lib-button
            id="time-range-pin"
            [size]="'custom'"
            [width]="26"
            [color]="'primary-link'"
            [image]="(sticky ? 'pinned' : 'pin') | imageSrc | async"
            (buttonClicked)="pinToggle()" >
          </lib-button>
        }
      </div>
      <div>
        <div class="d-flex align-items-center">
          <div class="months-dropdown-container d-flex align-items-stretch">
            <div class="calendar-range-icon d-flex align-items-center justify-content-center">
              <i
                class="far fa-calendar calendar-range-icon-symbol"
                [attr.aria-label]="'IMAGE_DESCRIPTION.CALENDAR' | translate"
                role="img"></i>
            </div>
            <lib-select
              [options]="months"
              [label]="selectedMonth"
              [size]="'small'"
              [classes]="'d-flex font-size-normal-small text-primary h-100 mr-1'"
              [notBold]="true"
              [fullWidth]="false"
              [doNotTranslate]="true"
              [itemClasses]="'font-size-normal-small'"
              [container]="''"
              (selectedChanged)="selectMonth($event)">
            </lib-select>
            <div class="border-left d-flex align-items-center">
              <lib-button
                id="months-dropdown-left"
                [size]="'custom'"
                [rounded]="'none'"
                [fontSize]="13"
                [color]="'primary-link'"
                [width]="22"
                [height]="22"
                [label]="'<'"
                [disabled]="selectedMonthIndex === (months.length - 1) || dataLoading"
                (buttonClicked)="previous()" >
              </lib-button>
            </div>
            <div class="border-left d-flex align-items-center">
              <lib-button
                id="months-dropdown-right"
                [size]="'custom'"
                [rounded]="'none'"
                [fontSize]="13"
                [color]="'primary-link'"
                [width]="22"
                [height]="22"
                [label]="'>'"
                [disabled]="!selectedMonthIndex || dataLoading"
                (buttonClicked)="next()" >
              </lib-button>
            </div>
          </div>
          <lib-content-box-buttons
            class="ml-2"
            [buttons]="buttons"
            [active]="activeButton"
            (activeChanged)="setRange($event)">
          </lib-content-box-buttons>
        </div>
        <div [ngClass]="showPicker ? 'd-flex' : 'd-none'" class="mt-1 justify-content-end">
          <app-custom-date-range
            [roundTime]="true"
            [openedPicker]="openDatePicker"
            [start]="tz(minSelectedTs)"
            [end]="tz(maxSelectedTs)"
            [minTime]="firstMonth"
            (setRange)="setCustomRange($event)">
          </app-custom-date-range>
        </div>
      </div>
    </div>
  </lib-card-header>
  <lib-card-body [fullContent]="true">
    <div class="range-slider-wrapper">
      @if (data) {
        <ngx-slider
          class="w-100"
          id="range-slider"
          [value]="minSelectedIndex"
          [highValue]="maxSelectedIndex"
          [options]="options"
          (userChangeEnd)="rangeUserChange($event)">
        </ngx-slider>
      }
      <div #tref id="range-slider-chart">
        <canvas #sliderCanvas height="64"></canvas>
      </div>
    </div>
  </lib-card-body>
</lib-card>
